'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('analysis_improvement_program', {
      url: '/account/stationaccess/analysis_improvement_program?jurisdiction&sta_recid',
      template: '<analysis-improvement-program></analysis-improvement-program>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null      // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/stationaccess/analysis_improvement_program/analysis_improvement_program.routes.js